export default __webpack_public_path__ + "static/media/Bezeni-COVER.a09d38e7.jpg";